
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <b>Marcel A., 85, verstorben am 16. November 2020</b>
    <br />
    <br />
    <i>Seine Tochter erzählt:</i>
    <br />
    <p>
  «Ich denke, dass zu viele Leute Covid-19 banalisieren. Sie behaupten, es
  handle sich um eine ungefährliche Grippe. Offenbar muss man die Auswirkungen
  dieses Virus aus nächster Nähe erleben, um zu erkennen, dass dies nicht
  stimmt. Wir sollten die Corona-Skeptiker auf die Intensivstation eines
  Krankenhauses schicken, um sie für die Realität zu sensibilisieren.
    </p>
    <p>
  Ich begleitete meinen Vater bis zu seinem letzten Atemzug auf der
  Intensivstation. Es war schrecklich. Sein Tod kam völlig unerwartet. Bevor er
  infiziert wurde, war Papa in bester Verfassung. Er lebte zu Hause bei Mama. Er
  hat sich um sie gekümmert, da sie an Alzheimer erkrankt ist. Er hat geputzt,
  die Wäsche gewaschen, gekocht. Er war unabhängig, bis das Coronavirus
  zuschlug.
    </p>
    <p>
  Anfang November sagte er mir, er fühle sich nicht wohl und habe
  Atembeschwerden. Da machten wir uns noch keine Sorgen. Wir hatten die
  Schutzmassnahmen immer eingehalten. Doch sein Gesundheitszustand
  verschlechterte sich über Nacht.
    </p>
    <p>
  Die häusliche Pflege brachte ihn ins Krankenhaus von Delémont. Vier Tage
  später war er tot. Ich habe miterlebt, wie die Atemprobleme fortschritten, die
  ihm die ganze Energie raubten. Obwohl er am Tag vor seinem Tod kaum mehr atmen
  konnte, haben ihn die Ärzte nie künstlich beatmet. Das war sein ausdrücklicher
  Wunsch. Er wollte das Risiko nicht eingehen, die Folgen eines künstlichen Koma
  zu erleiden und danach als Behinderter zu leben.
    </p>
    <p>
  Noch am Abend vor seinem Tod sagte der Arzt, dass sich sein Zustand bessere.
  Doch nach der dritten Morphiumspritze starb er in der Nacht.»
    </p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;